module.exports = __webpack_public_path__ + "img/play.7e1a3232.svg";